import React, { FC } from 'react';
import { CustomizedSelect } from 'src/atoms';
import styles from '../ChooseWorkspacePage.module.scss';
import { TDropdownOption } from '../model';
import cn from 'classnames';

type TWorkspaceDropdownProps = {
  selectedWorkspace: TDropdownOption;
  options: TDropdownOption[];
  onChangeValue: (value: TDropdownOption) => void;
  classes?: { root?: string };
  width?: number | string;
  isDisabled?: boolean;
};

export const WorkspaceDropdown: FC<TWorkspaceDropdownProps> = ({
  selectedWorkspace,
  options = [],
  onChangeValue,
  classes,
  width,
  isDisabled
}) => {
  return (
    <div className={cn(styles.dropdownWrapper, { [classes?.root || '']: !!classes?.root })}>
      <CustomizedSelect
        isDisabled={isDisabled}
        isSearchable={false}
        value={selectedWorkspace || { value: '', label: 'Select workspace' }}
        onChange={onChangeValue}
        options={options}
        customStyles={{
          container: {
            width: width || 350,
            minHeight: 35,
            height: 35,
            padding: '1px 10px 0px 6px',
            borderRadius: '5px'
          },

          singleValue: { fontWeight: 325, fontSize: '15px', lineHeight: 'normal', letterSpacing: '-0.78px' },

          menuList: {
            maxHeight: 195
          },
          option: {
            textAlign: 'left',
            justifyContent: 'flex-start',
            padding: '0.2em 0.3em',
            fontWeight: 325,
            fontSize: '15px',
            lineHeight: 'normal',
            letterSpacing: '-0.78px'
          }
        }}
      />
    </div>
  );
};

export default WorkspaceDropdown;
